import { useEffect, useRef, useState } from 'react';
import styles from './RollingCount.module.css';

/**
 * A count that rolls up when it grows (Jason, 18 Oct), like an odometer: the
 * new number arrives from below as the old one leaves upward. Only on a rise
 * seen while it is on screen; the first render, a fall and a change to text
 * such as "99+" just show the value. The old number is drawn by CSS from
 * `data-from`, so the element's text is only ever the current value.
 * Nothing moves under reduced motion (the CSS).
 */
export function RollingCount({ value, className }: { value: number | string; className?: string }) {
  const previous = useRef(value);
  const [roll, setRoll] = useState<{ from: number | string; key: number } | null>(null);

  useEffect(() => {
    const before = previous.current;
    previous.current = value;
    const was = Number.parseInt(String(before), 10);
    const now = Number.parseInt(String(value), 10);
    if (Number.isFinite(was) && Number.isFinite(now) && now > was) {
      setRoll((current) => ({ from: before, key: (current?.key ?? 0) + 1 }));
    }
  }, [value]);

  return (
    <span className={[styles.roll, className].filter(Boolean).join(' ')}>
      <span
        key={roll ? roll.key : 'steady'}
        className={roll ? styles.rolling : undefined}
        data-from={roll ? String(roll.from) : undefined}
      >
        {value}
      </span>
    </span>
  );
}
